export { default } from "ember-moment/helpers/moment-duration.js";
